import type { ExportProgress as ExportProgressType } from "@/hooks/useExport";
import styles from "./ExportProgress.module.css";

type ExportProgressProps = {
  label: string;
  progress: ExportProgressType;
  entityName?: string;
};

export function ExportProgress({ label, progress, entityName = "records" }: ExportProgressProps) {
  const getPhaseLabel = () => {
    switch (progress.phase) {
      case "fetching":
        return `Exporting ${entityName}...`;
      case "translating":
        return "Fetching translations...";
      case "generating":
        return "Generating CSV file...";
      case "done":
        return "Export complete!";
      default:
        return label;
    }
  };

  const getStatsLabel = () => {
    switch (progress.phase) {
      case "fetching":
        return `${progress.current.toLocaleString()} / ${progress.total.toLocaleString()} ${entityName}`;
      case "translating":
        return `${progress.current} / ${progress.total} languages processed`;
      case "generating":
        return "Processing...";
      case "done":
        return `${progress.current.toLocaleString()} ${entityName} exported`;
      default:
        return `${progress.current.toLocaleString()} of ${progress.total.toLocaleString()} records`;
    }
  };

  return (
    <div className={styles.exportProgress}>
      <div className={styles.exportProgressHeader}>
        <span className={styles.exportProgressText}>{getPhaseLabel()}</span>
        <span className={styles.exportProgressPercentage}>{progress.percentage}%</span>
      </div>
      <div className={styles.exportProgressBar}>
        <div
          className={styles.exportProgressBarFill}
          style={{ width: `${progress.percentage}%` }}
        />
      </div>
      <div className={styles.exportProgressStats}>{getStatsLabel()}</div>
    </div>
  );
}
